import Color from 'color';

import { PALETTE_COLORS } from './GlobalStylesConstants.js';
import { PaletteColorsCustomizable } from './GlobalStylesTypes.js';

/**
 * Stolen from https://mui.com/material-ui/react-avatar/#letter-avatars
 * Takes a string and returns a pseudo-random color
 *
 * ```js
 * stringToColor('Hello World') // #849a96
 *
 * ```
 */
export const stringToColor = (string: string) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};

export const getColor = (color: PaletteColorsCustomizable, on = false) => {
  return `${
    PALETTE_COLORS.includes(color as any)
      ? `var(--spz-sys-color-${on ? 'on-' : ''}${color})`
      : color
  }`;
};

/**
 * Gets the actual color value even if it is a variable
 * @param color
 */
export const getColorValue = (color: string, target: Element = document.body) => {
  if (color.startsWith('var(')) {
    const [, colorVar] = color.match(/var\((.+)\)/) || [];
    return getComputedStyle(target).getPropertyValue(colorVar);
  }

  return color;
};

export const getColorContrast = (color: string) => {
  const colorValue = getColorValue(getColor(color, true)) || '#000';
  return Color(colorValue).isDark() ? '#fff' : '#000';
};
